import React from "react";

const G8_LOGO_URI =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAClklEQVR4nI2TPWikZRSFn3vfLzNffubnmyQwSbR02UYWDEzjZtXYCCI4aCAgtm6wi8FqTRlhLbRMrEKIjcVabCvEv0AaGyEGC7VZomYw+jpOxszM977XYiZYuCue6t4L53Lu5RwBBLBKpbKoqk+NeuHhMEDM7MR7/xUgApBl2dvAuyKSPIL4L8QYP/DevyUzMzOLIYSvR/PwKMKVrDhsVYZoJiGEhoiYmUXnnDMzzAxVJcY4rAX6EfIIqQOBHNAQwtPJaKmoKt57zAznHP1+n3K5TJIkXOSRuVSZLsKPHaMXkdShQFQAVaXT6bC6usrR0REnJydsb2+TVStc9HJefXyMz55LuX8z5ZObRebHhUEEBbRYLNJut2k2m+zv73N6esru7i4rKyu8c+cOvW6XN58o8EMn8vznlzwz67g1q1wEo6Ag9Xr9dqvV2jk8PAxTU1Ou0WiwvLzMwsICWGT/3n1eqUe2bhT5/s/IY+PCC19eht8G4hKJ7ymAiDAxMYH3nlKpxMbGBuvr6+zs7FAtl7g1bfx8CfceBBKFF+cSLnMjYXgGAHt7eywtLbG2tsbm5iZ5nnN8/C2/t37h2bmUP/qRT88CWUFYrCkDG5GzLLtdq9VscnIy39rasvPzc+t2u3ZwcGDXr12zwviENa/P2ncr8/bra/P2xUt1e3K+lpeqNZupVu9KlmVviMiHZhba7bbLsow0TWmdnTFWKJCmKZ1+oFwQpgvCT38ZuRHGnbgQ493EzBIRsZEaBoMBvV6PUrl8ZVmmxoR+gAfd4efHFGzonyQBjq+cGkLIVVWcc8QY//G9gQoUZZimaJgIDvhGAKrV6vuquv5/gzRS9rH3/vWrjFilUnlZVRtmpvx3nAGOvfcfAfwNeoEeSUgBnqoAAAAASUVORK5CYII=";

/**
 * Slim attribution bar rendered at the bottom of every client site.
 * Links to https://grateful8.us — do not remove.
 */
export function G8AttributionBar() {
  const year = new Date().getFullYear();
  return (
    <div className="w-full py-3 px-6 flex justify-center bg-foreground">
      <a
        href="https://grateful8.us"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 text-background/35 hover:text-background/65 transition-colors group"
        aria-label="Built and powered by Grateful 8 Consulting"
      >
        <img
          src={G8_LOGO_URI}
          alt=""
          width={13}
          height={13}
          className="opacity-50 group-hover:opacity-75 transition-opacity"
        />
        <span className="text-[11px] tracking-wide">
          Built &amp; Powered by Grateful 8 Consulting &nbsp;·&nbsp; © {year} Grateful 8 Consulting
        </span>
      </a>
    </div>
  );
}
